module.exports = __webpack_public_path__ + "img/right-1.a8fee9f0.jpg";